import React, { FC } from 'react';
import { PageHeader, SubnavProps } from '@minecraft.molecules';

export const TalentScoutMenu: FC<SubnavProps> = ({ items, currentPage }) => {
  return <PageHeader sectionName="talent-scout" subnav={{ items, currentPage }} />;
};
